// QC #45 — same cache-isolation bug as useDeleteTeam. Use shared
// queryClient via useQueryClient() + invalidate the real cache keys.
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosClient } from '@/api/axiosClient';
import { useCallApi } from '@/hooks/useCallApi';
import { MutationOptions } from '@/models';
import { FormUpdateTeamTargetModel } from '@/modules/recruitment-plan/models';
import { fakeNetworkResponse, prepareDataToRequest, trans } from '@/utils';

function endpoint() {
  return `/recruitment-plan/update-team-target`;
}

export function useUpdateTeamTarget(options?: MutationOptions<boolean, FormUpdateTeamTargetModel>) {
  const { handleCallApi } = useCallApi();
  const queryClient = useQueryClient();
  const updateMessage = trans('GENERAL.ACTION.UPDATE.SUCCESS');

  function handler(form: FormUpdateTeamTargetModel) {
    return handleCallApi(
      async () => {
        await axiosClient.patch(endpoint(), prepareDataToRequest(form));
        queryClient.invalidateQueries({ queryKey: ['recruitment-detail'] });
        queryClient.invalidateQueries({ queryKey: ['recruitment-team-list'] });
        queryClient.invalidateQueries({ queryKey: ['recruitment-org'] });
        queryClient.invalidateQueries({ queryKey: ['filter-worker'] });

        return fakeNetworkResponse(true);
      },
      true,
      updateMessage
    );
  }

  return useMutation(handler, options);
}
